var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"efb9484660ea28d1b52990775da2d9faba7a8977"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://d1e9e7c95da388867f41cab9dc352c5e@o4504727560585216.ingest.us.sentry.io/4507813989842944",

  ignoreErrors: [
    // Ignore errors from one trusted domain
    'TypeError: Cannot read properties of undefined (reading \'Domain\')',
    'TypeError: undefined is not an object (evaluating \'t.Domain\')',
    
    // Ignore error bandai-component
    'TypeError: null is not an object (evaluating \'H.current.style\')',
    'TypeError: null is not an object (evaluating \'A.current.getBoundingClientRect\')',
  ],

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.01,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  replaysOnErrorSampleRate: 0.05,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.01,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
});

Sentry.setContext("document-referrer", { referrer: document.referrer });
